import { Component, Input, OnInit } from '@angular/core';
import { Section } from 'src/app/model/shared/section';

@Component({
  selector: 'app-api-reference-interface-design-section',
  templateUrl: './api-reference-interface-design-section.component.html',
  styleUrls: ['./api-reference-interface-design-section.component.scss']
})
export class ApiReferenceInterfaceDesignSectionComponent implements OnInit {
  @Input() sections: Section[] = [];

  constructor() {}

  ngOnInit(): void {}
}
